"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatHeader = require("./ChatHeader");
Object.keys(_ChatHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatHeader[key];
    }
  });
});